import { IProductTemplate } from 'shared/types/ProductTemplate';
import { getSpecialTypeDataMap } from 'productTemplate/utils/specialTypeDataMap';

export const isSpecialType = (variantType: IProductTemplate['specialType']) => {
  return getSpecialTypeDataMap()[variantType] !== undefined;
};
